import { SelectionModel } from '@angular/cdk/collections';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, EstadosExpediente, EstadosExpedientePerito } from '@models/base/identificadores.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { ExpedienteFilter } from '@models/expediente/expedienteFilter.model';
import { EstadoExpedienteService } from '@services/estadoExpediente/estadoExpediente.service';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoExpedienteService } from '@services/tipoExpediente/tipoExpediente.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { DialogExpedientesEnviadosComponent } from '../dialog-expedientes-enviados/dialog-expedientes-enviados.component';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { createFilterPredicate } from '@helpers/search/createFilterPredicate';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRoleDirective } from '@directives/appRoles/app-role.directive';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonExportExcelComponent } from 'src/app/component/button-export-excel/button-export-excel.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActionButtonsFilterComponent } from '@component/action-buttons-filter/action-buttons-filter.component';
import { InputFilterTableComponent } from '@component/input-filter-table/input-filter-table.component';

@Component({
  standalone: true,
  imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, SinDatosParaMostrarComponent, ButtonNewComponent, SinDatosParaMostrarComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, ButtonFilterTableComponent, ButtonExportFileComponent, ButtonActionComponent, SinDatosParaMostrarComponent, MatTooltipModule, MatPaginatorModule, MatRippleModule, RouterModule, MatCheckboxModule, ButtonFilterTableClearComponent, ButtonExportExcelComponent,ActionButtonsFilterComponent,InputFilterTableComponent],
  selector: 'app-list-expediente',
  templateUrl: './list-expediente.component.html',
  styleUrls: ['./list-expediente.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 1 })),
      state('out', style({ height: '0', opacity: 0 })),
      transition('in <=> out', animate('300ms ease-in-out'))
    ])
  ]
})
export class ListExpedienteComponent {
  columns = [
    { header: 'Descripción', key: 'descripcion' },
    { header: 'Observaciones', key: 'observaciones' },
    { header: 'Fecha de Alta', key: 'fechaAlta' },
    { header: 'Ubicación', key: 'ubicacion' },
    { header: 'Carátula', key: 'caratula' },
    { header: 'CUIJ', key: 'identificadorUnico' },
    { header: 'Número', key: 'numero' },
    { header: 'Demanda', key: 'demanda' },
    { header: 'Demandado', key: 'demandado' },
    { header: 'Causa', key: 'causa' },
    { header: 'Número de Carpeta', key: 'numeroCarpeta' },
    { header: 'Número de Archivo', key: 'numeroArchivo' },
    { header: 'Responsable', key: 'responsable' },
    { header: 'Separador Carátula', key: 'separadorCaratula' },
    { header: 'Activo', key: 'activo' },
    { header: 'Estado del Expediente', key: 'estadoExpediente' },
    { header: 'Juzgado', key: 'juzgado' },
    { header: 'Tipo de Expediente', key: 'tipoExpediente' },
    { header: 'Clave SISFE', key: 'claveExpediente' },
    { header: 'Sufijo', key: 'sufijo' },
    { header: 'Bis', key: 'bis' },
    { header: 'Fecha Ingreso MEU', key: 'fechaIngresoMEU' },
    { header: 'Fecha de Modificación', key: 'fechaModificacion' },
    { header: 'Fecha de Baja', key: 'fechaBaja' },
    { header: 'Monto de la Demanda', key: 'montoDemanda' },
    { header: 'Persona', key: 'persona' },
    { header: 'Estado Procesal', key: 'estadoProcesal' },
    { header: 'Fecha de Inicio', key: 'fechaInicio' },
    { header: 'Fecha de Fin', key: 'fechaFin' },
    { header: 'Tipo de Grupo de Expediente', key: 'tipoGrupoExpediente' },
    { header: 'Tipo de Prioridad', key: 'tipoPrioridad' },
    { header: 'Asignado A', key: 'asignadoA' }
  ];



  selection = new SelectionModel<ExpedienteDto>(true, []);
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<ExpedienteDto>();
  isLoading: boolean = true;
  errorMessage: string = "";
  @Input() idCaso!: number
  @Input() idPersona!: number

  isChecked: boolean = false;

  formBuilder: FormBuilder = new FormBuilder;
  formFilter: FormGroup;
  estadosExpediente!: BaseDto[];
  estadosExpedientePerito!: BaseDto[];
  checkedFiltroAvanzado = false;
  tiposExpediente!: BaseDto[];
  juzgados: JuzgadoDto[] = [];
  expedienteFilter!: ExpedienteFilter;
  expedienteDatosPlanos!: {
    descripcion: string; observaciones: string;
    fechaAlta: string, ubicacion: string; caratula: string; identificadorUnico: string; numero: string; demanda: string; demandado: string; causa: string; numeroCarpeta: string; numeroArchivo: string; responsable: string; separadorCaratula: string; activo: string; estadoExpediente: string; juzgado: string; tipoExpediente: string; claveExpediente: string; sufijo: string; bis: string; fechaIngresoMEU: string; fechaModificacion: string; fechaBaja: string; montoDemanda: number; persona: string; estadoProcesal: string; fechaInicio: string; fechaFin: string; tipoGrupoExpediente: string; tipoPrioridad: string; asignadoA: string;
  }[];
  constructor(
    private ExpedienteService: ExpedienteService,
    private juzgadoService: JuzgadoService,
    private tipoExpedienteService: TipoExpedienteService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private EstadoExpedienteService: EstadoExpedienteService,
    private dialog: MatDialog,
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["select", "caratula", "accion"] :
        ["select", "caratula", "identificadorUnico", "estadoExpediente", "fechaModificacion", "accion"];
    });


    this.formFilter = this.formBuilder.group({
      EstadoExpediente: [''],
      Caratula: [''],
      Numero: [''],
      IdentificadorUnico: [''],
      Juzgado: [''],
      TipoExpediente: [''],
      ClaveSisfe: [''],
    })

    this.dataSource.filterPredicate = createFilterPredicate<ExpedienteDto>();

  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
    this.getAllJuzgados();
    const expedientes = this.ExpedienteService.getExpedientes();
    if (expedientes)
      if (expedientes.length >= 1) {
        this.data = true
        this.dataSource.data = expedientes
      }

    if (this.idCaso) {
      this.getAllExpedienteByCaso(this.idCaso)
    }

    if (this.idPersona)
      this.getAllExpedienteByIdPersona(this.idPersona)

    const filtroExpedientesGuardado = localStorage.getItem('filtroExpedientesGuardado');
    if (filtroExpedientesGuardado) {
      const filtro: ExpedienteFilter = JSON.parse(filtroExpedientesGuardado);
      this.formFilter.patchValue(filtro);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.idCaso)
      this.getAllExpedienteByCaso(this.idCaso)

    if (this.idPersona)
      this.getAllExpedienteByIdPersona(this.idPersona)
  }


  aplicarFiltro() {
    this.expedienteFilter = new ExpedienteFilter

    this.expedienteFilter.caratula = isFalsy(this.formFilter.controls['Caratula'].value) ? null : this.formFilter.controls['Caratula'].value;

    this.expedienteFilter.identificadorUnico = isFalsy(this.formFilter.controls['IdentificadorUnico'].value) ? null : this.formFilter.controls['IdentificadorUnico'].value;

    this.expedienteFilter.numero = isFalsy(this.formFilter.controls['Numero'].value) ? null : this.formFilter.controls['Numero'].value;

    this.expedienteFilter.idsTipoExpediente = isFalsy(this.formFilter.controls['TipoExpediente'].value) ? null : this.formFilter.controls['TipoExpediente'].value;

    this.expedienteFilter.idsEstadoExpediente = isFalsy(this.formFilter.controls['EstadoExpediente'].value) ? null : this.formFilter.controls['EstadoExpediente'].value;

    this.expedienteFilter.idsJuzgados = isFalsy(this.formFilter.controls['Juzgado'].value) ? null : this.formFilter.controls['Juzgado'].value;

    this.expedienteFilter.sinClave = isFalsy(this.formFilter.controls['ClaveSisfe'].value) ? null : this.formFilter.controls['ClaveSisfe'].value;

    this.getAllExpedientesByFilter(this.expedienteFilter)
    this.guardarFiltro();
  }


  guardarFiltro() {
    const filtro: ExpedienteFilter = this.formFilter.value;
    localStorage.setItem('filtroExpedientesGuardado', JSON.stringify(filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroExpedientesGuardado');
  }


  onMenuOpened() {
    this.checkedFiltroAvanzado = true;
    this.getAllTiposExpediente();
    this.getAllJuzgados();
    this.getAllEstadosExpediente();
  }

  onMenuClosed() {
    this.checkedFiltroAvanzado = false;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAllExpedientesByFilter(expedienteFilter: ExpedienteFilter) {
    this.spinner.show('spExpediente')
    this.ExpedienteService.getAllExpedientesByFilter(expedienteFilter)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.dataSource.data = data.sort((a, b) => a.caratula.toString().localeCompare(b.caratula.toString())) as ExpedienteDto[]
          this.data = this.dataSource.data.length >= 1 ? true : false

          this.ExpedienteService.setExpedientes(this.dataSource.data)
          this.obtenerDatosPlanos();

        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllExpedienteByCaso(idCaso: number) {
    this.spinner.show('spExpediente')
    this.ExpedienteService.getAllByCaso(idCaso)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.dataSource.data = data.sort((a, b) => a.caratula.toString().localeCompare(b.caratula.toString())) as ExpedienteDto[]
          this.data = this.dataSource.data.length >= 1 ? true : false

          let estadoExpediente = this.formFilter.controls["EstadoExpediente"].value

          if (estadoExpediente >= 1)
            this.dataSource.data = this.dataSource.data.filter(x => x.estadoExpediente.id == estadoExpediente)


          this.ExpedienteService.setExpedientes(this.dataSource.data)
        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllExpedienteByIdPersona(idPersona: number) {

    if (idPersona) {
      this.spinner.show('spExpediente')
      this.expedienteFilter = new ExpedienteFilter()
      if (!this.expedienteFilter.idsPersona) {
        this.expedienteFilter.idsPersona = [];
      }
      this.expedienteFilter.idsPersona.push(Number(idPersona));
      this.ExpedienteService.getAllExpedientesByFilter(this.expedienteFilter)
        .subscribe(
          data => {
            this.spinner.hide('spExpediente')
            this.dataSource.data = data.sort((a, b) => a.caratula.toString().localeCompare(b.caratula.toString())) as ExpedienteDto[]
            this.data = this.dataSource.data.length >= 1 ? true : false

            let estadoExpediente = this.formFilter.controls["EstadoExpediente"].value

            if (estadoExpediente >= 1)
              this.dataSource.data = this.dataSource.data.filter(x => x.estadoExpediente.id == estadoExpediente)


            this.ExpedienteService.setExpedientes(this.dataSource.data)
          },
          error => {
            this.spinner.hide('spExpediente')
            this.snackBar.showError(error, "Error");
          })
    }
  }

  selectValue(event: any) {
    if (!isFalsy(event)) {
      this.expedienteFilter.idsJuzgados = event.id;
    }
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%",
      dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogDeleteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  deleteRowData(id: number) {
    this.spinner.show('spExpediente')
    this.ExpedienteService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          this.getAllExpedientesByFilter(this.expedienteFilter);
        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        });
  }


  getAllEstadosExpediente() {
    this.spinner.show("spBusquedaEstadoExpediente")
    this.EstadoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaEstadoExpediente")
          let todos = new BaseDto
          todos.id = 0
          todos.descripcion = "Todos"
          data.push(todos)
          this.estadosExpediente = data
        },
        error => {
          this.spinner.hide("spBusquedaEstadoExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTiposExpediente() {
    this.spinner.show("spBusquedaTipoExpediente")
    this.tipoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaTipoExpediente")
          let todos = new BaseDto
          todos.id = 0
          todos.descripcion = "Todos"
          data.push(todos)
          this.tiposExpediente = data
        },
        error => {
          this.spinner.hide("spBusquedaTipoExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllJuzgados() {
    this.spinner.show("spBusquedaJuzgados")
    this.juzgadoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaJuzgados")
          let todos = new JuzgadoDto
          todos.id = 0
          todos.descripcion = "Todos"
          data.push(todos)
          this.juzgados = data
        },
        error => {
          this.spinner.hide("spBusquedaJuzgados")
          this.snackBar.showError(error, "Error");
        })
  }

  solicitarClavePorCorreo() {
    let idsExpedientesFiltrar: number[] = []
    this.selection.selected.forEach(element => {
      idsExpedientesFiltrar.push(element.id)
    });

    this.spinner.show("spExpediente")
    this.ExpedienteService.solicitarClavePorCorreoAJuzgado(idsExpedientesFiltrar)
      .subscribe(
        data => {
          this.spinner.hide("spExpediente")

          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = "90%"
          dialogConfig.autoFocus = false;
          dialogConfig.data = data

          const dialogRef = this.dialog.open(DialogExpedientesEnviadosComponent, dialogConfig);

        },
        error => {
          this.spinner.hide("spExpediente")
          this.snackBar.showError(error, "Error");
        })

  }

  obtenerDatosPlanos() {
    this.expedienteDatosPlanos = this.dataSource.data.map(item => ({
      descripcion: item.descripcion,
      observaciones: item.observaciones,
      fechaAlta: item.fechaAlta ? new Date(item.fechaAlta).toLocaleDateString() : '',
      ubicacion: item.ubicacion,
      caratula: item.caratula,
      identificadorUnico: item.identificadorUnico,
      numero: item.numero,
      demanda: item.demanda,
      demandado: item.demandado,
      causa: item.causa,
      numeroCarpeta: item.numeroCarpeta,
      numeroArchivo: item.numeroArchivo,
      responsable: item.responsable,
      separadorCaratula: item.separadorCaratula,
      activo: item.activo ? 'Sí' : 'No',
      estadoExpediente: item.estadoExpediente?.descripcion ?? '',
      juzgado: item.juzgado?.nombre ?? '',
      tipoExpediente: item.tipoExpediente?.descripcion ?? '',
      claveExpediente: item.claveExpediente,
      sufijo: item.sufijo,
      bis: item.bis,
      fechaIngresoMEU: item.fechaIngresoMEU ? new Date(item.fechaIngresoMEU).toLocaleDateString() : '',
      fechaModificacion: item.fechaModificacion ? new Date(item.fechaModificacion).toLocaleDateString() : '',
      fechaBaja: item.fechaBaja ? new Date(item.fechaBaja).toLocaleDateString() : '',
      montoDemanda: item.montoDemanda,
      persona: item.persona?.nombreCompleto ?? '',
      estadoProcesal: item.estadoProcesal?.descripcion ?? '',
      fechaInicio: item.fechaInicio ? new Date(item.fechaInicio).toLocaleDateString() : '',
      fechaFin: item.fechaFin ? new Date(item.fechaFin).toLocaleDateString() : '',
      tipoGrupoExpediente: item.tipoGrupoExpediente?.descripcion ?? '',
      tipoPrioridad: item.tipoPrioridad?.descripcion ?? '',
      asignadoA: item.asignadoA
        ? `${item.asignadoA.nombre ?? ''} ${item.asignadoA.apellido ?? ''}`.trim()
        : ''
    }));
  }



  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: ExpedienteDto): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  trackByItems(index: number, item: any): any { return item; }
}
